module.exports = __webpack_public_path__ + "static/img/sh3.daf9863.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sh3.svg
// module id = FH9Y
// module chunks = 1